import React from 'react'
import { withRedirectUrl } from '@ztechapps/common.utils'
import { Alert, Link as LinkNative, ShowIf } from '@ztechapps/webui.util'
import { BasicLoginForm, ForgotPassword } from '@ztechapps/webui.auth'
import { appSettings } from '../../../config/settings'
import { useContext } from './Context'
import { PageTitle } from '../../../components/PageTitle'

export type BasicAuthLayoutProps = { initialAlertMessage?: string; alertType?: string }

export const BasicAuthLayout = ({ initialAlertMessage, alertType }: BasicAuthLayoutProps) => {
  const { redirectUrl } = useContext()

  const [isLoginScreen, setIsLoginScreen] = React.useState(true)
  const recaptchaSiteKey = appSettings.Google.recaptchaSiteKey
  const showLoginScreen = (e) => {
    e.preventDefault()
    setIsLoginScreen(true)
  }

  const forgotPasswordComponent = (
    <div className="my-3 d-flex justify-content-end">
      <LinkNative
        onClick={(e) => {
          e.preventDefault()
          setIsLoginScreen(false)
        }}
      >
        <small>Forgot your password?</small>
      </LinkNative>
    </div>
  )

  return (
    <div>
      <PageTitle title="Sign In" description="Sign in to your account to access your orders, wishlist, and more." />
      <ShowIf condition={!!initialAlertMessage}>
        <Alert type={alertType}>{initialAlertMessage}</Alert>
      </ShowIf>

      <ShowIf condition={isLoginScreen}>
        <h4 className="mb-4">Sign in</h4>

        <BasicLoginForm
          forgotPasswordComponent={forgotPasswordComponent}
          formAction={withRedirectUrl('/api/auth/basic/pp-store', redirectUrl)}
          recaptchaSiteKey={recaptchaSiteKey}
        />
      </ShowIf>
      <ShowIf condition={!isLoginScreen}>
        <h4 className="mb-4">Reset Password</h4>

        <ForgotPassword url="/api/auth/basic/pp-store/forgot-password" recaptchaSiteKey={recaptchaSiteKey} />
        <div>
          <p>
            Already have login and password?
            <LinkNative onClick={showLoginScreen}>&nbsp;&nbsp;Sign in</LinkNative>
          </p>
        </div>
      </ShowIf>
    </div>
  )
}
